import React from 'react';

import MaskedInput from 'react-text-mask';


const SsnLastFourMask = ({ ...props }) => {
    return <MaskedInput {...props} guide={false} mask={[/[0-9]/, /\d/, /\d/, /\d/]} inputMode="numeric" />
}

export default SsnLastFourMask